import { Administrator, ADMINISTRATOR } from '@favid-inc/api';
import { formFactory, FormValues } from 'core/form';
import { FormField } from 'core/form';
import { Action } from 'core/generic';
import React from 'react';
import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import { insertAdmin } from './claim/controller';

const fieldList: FormField[] = [{ name: 'email', label: 'Email' }];

const Form = formFactory<Administrator>(ADMINISTRATOR);

const email = (value: string) =>
  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? { email: 'Email inválido' } : {};

const validate = (formValues: { email: string }) => {
  return email(formValues.email);
};

interface Props {
  list: Administrator[];
  dispatch: (action: Action) => void;
}

class CreateAdminComponent extends React.Component<Props> {
  onSubmit = async (params: FormValues) => {
    try {
      insertAdmin(params.email, this.props.dispatch);
    } catch (e) {
      if (e instanceof SubmissionError) {
        throw e;
      }
      toast.error('Ocorreu um erro ao cadastrar o administrador, tente novamente');
    }
  };

  render() {
    return (
      <div>
        <div className='ui header'>
          <h3>Adicionar administrador</h3>
        </div>
        <Form fieldList={fieldList} submitHandler={this.onSubmit} validate={validate} />
      </div>
    );
  }
}

export const CreateAdmin = CreateAdminComponent;
